// FunctionalSpecification.js — Spécifications fonctionnelles (HUB).
// Assemble les POC interactifs des écrans des 3 groupes ScanBank (Paramétrage / Suivi d'audit / Rapports & Supervision).
// Navigation : Module -> Écran -> rend le composant POC correspondant (réplique IHM + guide utilisateur).
// Chaque écran est un composant autonome dans src/components/functional/*POC.js.
import React, { useState } from 'react';
import { Icon } from '../components/ui';

// Paramétrage
import DomainesPOC from '../components/functional/DomainesPOC';
import ReferentielControlesPOC from '../components/functional/ReferentielControlesPOC';
// Suivi d'audit
import SessionsPOC from '../components/functional/SessionsPOC';
import ControlesExecutesPOC from '../components/functional/ControlesExecutesPOC';
import AnomaliesPOC from '../components/functional/AnomaliesPOC';
import RecommandationsPOC from '../components/functional/RecommandationsPOC';
// Rapports & Supervision
import DashboardPOC from '../components/functional/DashboardPOC';
import SessionReportsPOC from '../components/functional/SessionReportsPOC';
import DomainDashboardPOC from '../components/functional/DomainDashboardPOC';
import SupervisionPOC from '../components/functional/SupervisionPOC';

const MODULES = [
  {
    key: 'PARAMETRAGE', label: 'Paramétrage', color: '#6366F1', icon: 'Settings2',
    screens: [
      { key: 'domaines', title: "Domaines d'audit & modules CBS", Comp: DomainesPOC },
      { key: 'referentielControles', title: 'Référentiel des contrôles', Comp: ReferentielControlesPOC },
    ],
  },
  {
    key: 'AUDIT', label: "Suivi d'audit", color: '#3B82F6', icon: 'Activity',
    screens: [
      { key: 'sessions', title: "Sessions d'audit & import XML", Comp: SessionsPOC },
      { key: 'controlesExecutes', title: 'Contrôles exécutés', Comp: ControlesExecutesPOC },
      { key: 'anomalies', title: 'Anomalies & résolution', Comp: AnomaliesPOC },
      { key: 'recommandations', title: 'Recommandations', Comp: RecommandationsPOC },
    ],
  },
  {
    key: 'REPORTS', label: 'Rapports & Supervision', color: '#10B981', icon: 'BarChart3',
    screens: [
      { key: 'dashboard', title: "Dashboard d'accueil", Comp: DashboardPOC },
      { key: 'sessionReports', title: 'Rapports de session', Comp: SessionReportsPOC },
      { key: 'domainDashboard', title: 'Dashboard domaine', Comp: DomainDashboardPOC },
      { key: 'supervision', title: 'Supervision domaines × modules', Comp: SupervisionPOC },
    ],
  },
];

const FunctionalSpecification = () => {
  const [moduleKey, setModuleKey] = useState(MODULES[0].key);
  const [screenKey, setScreenKey] = useState(MODULES[0].screens[0].key);

  const module = MODULES.find((m) => m.key === moduleKey) || MODULES[0];
  const screen = module.screens.find((s) => s.key === screenKey) || module.screens[0];
  const ScreenComp = screen.Comp;

  const selectModule = (m) => { setModuleKey(m.key); setScreenKey(m.screens[0].key); };

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-900 dark:text-white">Spécifications fonctionnelles</h1>
        <p className="mt-1 text-gray-600 dark:text-gray-300">Maquettes interactives des écrans ScanBank, par groupe fonctionnel. Sélectionnez un groupe puis un écran — chaque écran propose une réplique de l'IHM et un guide pas-à-pas.</p>
      </div>

      {/* Sélecteur de module */}
      <div className="flex flex-wrap gap-2">
        {MODULES.map((m) => {
          const on = m.key === moduleKey;
          return (
            <button key={m.key} onClick={() => selectModule(m)}
              style={on ? { backgroundColor: m.color, borderColor: m.color, color: '#fff' } : undefined}
              className={`px-4 py-2 rounded-lg text-sm font-semibold flex items-center gap-2 border transition-colors ${on ? '' : 'bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-200 border-gray-300 dark:border-gray-600 hover:bg-gray-100 dark:hover:bg-gray-700'}`}>
              <Icon name={m.icon} className="h-4 w-4" />{m.label}
              <span className={`text-xs ${on ? 'text-white/80' : 'text-gray-400'}`}>({m.screens.length})</span>
            </button>
          );
        })}
      </div>

      {/* Sélecteur d'écran */}
      <div className="flex flex-wrap gap-2 border-b border-gray-200 dark:border-gray-700 pb-3">
        {module.screens.map((s) => {
          const on = s.key === screenKey;
          return (
            <button key={s.key} onClick={() => setScreenKey(s.key)}
              className={`px-3 py-1.5 rounded-full text-sm font-medium transition-colors ${on ? 'bg-blue-500 text-white' : 'bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-600'}`}>
              {s.title}
            </button>
          );
        })}
      </div>

      {/* Écran sélectionné (POC) */}
      <div key={`${moduleKey}-${screenKey}`}>
        <ScreenComp />
      </div>
    </div>
  );
};

export default FunctionalSpecification;
